import { styled } from "@mui/material";
import FA__PaperPlane from "../../../assets/icons/paper-plane-top-regular-full.svg";

const SendMessageIcon = styled("div")(() => ({
  width: "24px",
  height: "24px",
  mask: `url("${FA__PaperPlane}") no-repeat center / contain`,
  WebkitMask: `url("${FA__PaperPlane}") no-repeat center / contain`,
  backgroundColor: "currentColor",
}));

export default SendMessageIcon;
